// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"_fc3510","title":"_7dde8e","text":"_8cafda","divider":"_0fe0d3","icon":"_25248e","iconCons":"_aed6d8","iconPros":"_ffe06a"};